export class GcpPrincipal {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "serviceAccountEmail",
            "baseName": "serviceAccountEmail",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpPrincipal.attributeTypeMap;
    }
    constructor() {
    }
}
